import { api, getAuthHeaders } from "../axios";

export async function deleteFirmwareVersion(
  firmwareId: number,
  versionId: number,
): Promise<void> {
  await api.delete(`/firmwares/${firmwareId}/versions`, {
    headers: getAuthHeaders(),
    data: {
      firmware_version_id: versionId,
    },
  });
}
